import fetch from 'isomorphic-fetch'
import { WP_URL } from '../wp-url'
import _ from 'lodash'

export const RECEIVE_SITE_INFO = 'RECEIVE_SITE_INFO'
export const RECEIVE_SITE_OPTIONS = 'RECEIVE_SITE_OPTIONS'
export const RECEIVE_PAGE = 'RECEIVE_PAGE'
export const RECEIVE_MENUITEMS = 'RECEIVE_MENUITEMS'
export const RECEIVE_CUSTOM_POSTS = 'RECEIVE_CUSTOM_POSTS'
export const RECEIVE_THUMB = 'RECEIVE_THUMB'
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES'

export const SET_CAT_FILTER = 'SET_CAT_FILTER'

export const LOADING_PAGES = 'LOADING_PAGES'
export const LOADING_POSTS = 'LOADING_POSTS'
export const LOADING_MENU = 'LOADING_MENU'
export const LOADING_SITEINFO = 'LOADING_SITEINFO'
export const LOADING_THUMBS = 'LOADING_THUMBS'
export const LOADING_CATEGORIES = 'LOADING_CATEGORIES'

export const TOGGLE_VIDEO = 'TOGGLE_VIDEO'

function loadingPages(bool) {
    return {
        type: LOADING_PAGES,
        payload: {
            loading: bool
        }
    }
}
function loadingPosts(bool) {
    return {
        type: LOADING_POSTS,
        payload: {
            loading: bool
        }
    }
}
function loadingMenu(bool) {
    return {
        type: LOADING_MENU,
        payload: {
            loading: bool
        }
    }
}
function loadingSiteInfo(bool) {
    return {
        type: LOADING_SITEINFO,
        payload: {
            loading: bool
        }
    }
}
// function loadingThumbs(bool) {
//     return {
//         type: LOADING_THUMBS,
//         payload: {
//             loading: bool
//         }
//     }
// }
function loadingCategories(bool) {
    return {
        type: LOADING_CATEGORIES,
        payload: {
            loading: bool
        }
    }
}

//play video
export function toggleVideo(bool) {
    return {
        type: TOGGLE_VIDEO, 
        payload: bool,
    }
}

//get global site info
export function fetchSiteInfo() {
    return function (dispatch, getState) {
        if (shouldFetchSiteInfo(getState())) {
            dispatch(loadingSiteInfo(true))
            return fetch(WP_URL, {credentials: 'same-origin'})
                .then(response => response.json())
                .then(data => dispatch(receiveSiteInfo(dispatch, data)))
            }
    }
}

function shouldFetchSiteInfo(state) {
    const siteInfo = state.siteinfo
    return !siteInfo.hasOwnProperty('siteInfo');
}

function receiveSiteInfo(dispatch, data) {
    dispatch(loadingSiteInfo(false))
    return {
        type: RECEIVE_SITE_INFO,
        payload: {
            siteInfo: data
        }
    }
}

//get sitewide options
export function fetchSiteOptions() {
    return function (dispatch, getState) {
        if (shouldFetchSiteOptions(getState())) {
            return fetch(WP_URL + '/custom_routes/general_options', {credentials: 'same-origin'})
                .then(response => response.json())
                .then(data => dispatch(receiveSiteOptions(dispatch, data)))
            }
    }
}

function shouldFetchSiteOptions(state) {
    const siteoptions = state.siteoptions
    return !siteoptions.hasOwnProperty('siteoptions');
}

function receiveSiteOptions(dispatch, data) {
    return {
        type: RECEIVE_SITE_OPTIONS,
        payload: {
            siteoptions: data
        }
    }
}


//get a page, based on its name
export function fetchPageIfNeeded(pageName) {
    return function(dispatch, getState) {
        if (shouldFetchPage(getState(), pageName)) {
            dispatch(loadingPages(true))
            return fetch(WP_URL + '/wp/v2/pages?slug=' + pageName, {credentials: 'same-origin'})
                .then(response => response.json())
                .then(pages => dispatch(receivePage(dispatch, pageName, pages[0])))
        }
    }
}

function shouldFetchPage(state, pageName) {
    const pages = state.pages
    return !pages.hasOwnProperty(pageName)
}

function receivePage(dispatch, pageName, pageData) {
    dispatch(loadingPages(false))
    // !_.isEmpty(pageData) && dispatch(fetchThumbIfNeeded(pageData.featured_media))
    return {
        type: RECEIVE_PAGE,
        payload: {
            pageName: pageName,
            page: pageData
        }
    }
}

//get all the menu items, custom route needed for now
export function fetchMenuItems() {
    return function (dispatch, getState) {
        if (shouldFetchMenuItems(getState())) {
            dispatch(loadingMenu(true))
            return fetch(WP_URL + '/custom_routes/menu', {credentials: 'same-origin'})
                .then(response => response.json())
                .then(menuData => dispatch(receiveMenuItems(dispatch, menuData)))
            }
    }
}

function shouldFetchMenuItems(state) {
    const menu = state.menu
    return !menu.hasOwnProperty('menuItems');
}

function receiveMenuItems(dispatch, menuData) {
    dispatch(loadingMenu(false))
    return {
        type: RECEIVE_MENUITEMS,
        payload: {
            menuItems: menuData
        }
    }
}

//custom posts, get them all for 'work' posttype, as these need to be displayed on one page
export function fetchCustomPostsIfNeeded(postType) {
    return function(dispatch, getState) {
        if (shouldFetchCustomPosts(getState(), postType)) {
            dispatch(loadingPosts(true))
            return fetch(WP_URL + '/wp/v2/' + postType + '?per_page=100&orderby=title&order=asc', {credentials: 'same-origin'})
                .then(response => response.json())
                .then(posts => dispatch(receiveCustomPosts(dispatch, postType, posts)))
        }
    }
}

function shouldFetchCustomPosts(state, postType) {
    const posts = state.customposts;
    return !posts.hasOwnProperty(postType);
}

function receiveCustomPosts(dispatch, postType, posts) {
    dispatch(loadingPosts(false))
    // posts.map( (post) => dispatch(fetchThumbIfNeeded(post.featured_media)) )
    const sortedPosts = _.sortBy( posts, 'menu_order' )
    return {
        type: RECEIVE_CUSTOM_POSTS,
        payload: {
            postType: postType,
            posts: sortedPosts
        }
    }
}

//all categories
export function fetchCategoriesIfNeeded() {
    return function(dispatch, getState) {
        if (shouldFetchCategories(getState())) {
            dispatch(loadingCategories(true))
            return fetch(WP_URL + '/wp/v2/categories', {credentials: 'same-origin'})
                .then(response => response.json())
                .then(categories => dispatch(receiveCategories(dispatch, categories)))
        }
    }
}

function shouldFetchCategories(state) {
    const categories = state.categories;
    return !categories.hasOwnProperty('categories');
}

function receiveCategories(dispatch, categories) {
    dispatch(loadingCategories(false))
    return {
        type: RECEIVE_CATEGORIES,
        payload: {
            categories: categories
        }
    }
}

//filter cats checkboxes
export function setCatFilter(slug) {
    return {
        type: SET_CAT_FILTER,
        payload: slug,
    }
}

//thumbs
export function fetchThumbIfNeeded(thumbID) {
    return function(dispatch, getState) {
        if (shouldFetchThumb(getState(), thumbID)) {
            // dispatch(loadingThumbs(true))
            return fetch(WP_URL + '/wp/v2/media/' + thumbID, {credentials: 'same-origin'})
                .then(response => response.json())
                .then(thumb => dispatch(receiveThumb(dispatch, thumbID, thumb)) )
        }
    }
}

function shouldFetchThumb(state, thumbID) {
    const thumb = state.thumb;
    return thumbID === parseInt(thumbID, 10) && !thumb.hasOwnProperty(thumbID);
}

function receiveThumb(dispatch, thumbID, thumb) {
    // dispatch(loadingThumbs(false))
    return {
        type: RECEIVE_THUMB,
        payload: {
            thumbID: thumbID,
            thumb: thumb
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js